module.exports = __webpack_public_path__ + "img/search.afb4f8be.svg";